export enum MemberStatusEnum {
  NewMember = 1, // Intresseanmäld
  Paid = 2, // Betald
  NotPaid = 3, // Ej betald
  NotMember = 4, // Utträdd
}
